import React from "react";
import { Drawer } from "@mui/material";
import DrawerHeader from "../helpers/DrawerHeader.js";
import DrawerFooterContainerSmall from "../helpers/DrawerFooterContainerSmall.js";
import ButtonFilled from "../helpers/ButtonFilled.js";
import ButtonGrayed from "../helpers/ButtonGrayed.js";
import ButtonFilledCancel from "../helpers/ButtonFilledCancel.js";
import ModalInfoCard from "../helpers/ModalInfoCard.js";
import ModalUserStatusCard from "../helpers/ModalUserStatusCard.js";
import { formatDateReadable } from "../../utilities/helpers.js";
import { get_t_str } from "../../../../../helpers/helpers.js";
import {
  CalendarToday,
  DescriptionOutlined,
  ChatBubbleOutline,
  Send,
  AccessTime,
  LocalOfferOutlined
} from '@mui/icons-material';

const TimeOffMineDrawer = (props) => {
  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    props.setDrawerOpen(open);
  };

  const handleRescindSubmit = () => {
    props.rescind_time_off_request(props.requestInfo.id);
    props.setDrawerOpen(false);
  };

  return (
    <Drawer anchor="right" open={props.isDrawerOpen} onClose={toggleDrawer(false)}>
      <div className="w-[450px] h-screen bg-white relative">
        <div className="max-h-screen overflow-auto">
          <DrawerHeader
            title="Time off request"
            onClose={toggleDrawer(false)}
          />
          <div className="px-6 py-5">
            {/* User Status Section */}
            <div className="mb-6">
              <ModalUserStatusCard
                status={props.requestInfo.status.toLowerCase()}
                name="Your Time Off Request"
                icon={CalendarToday}
              />
            </div>

            {/* Info Cards */}
            <div className="w-full">
              <div className="mb-4">
                <ModalInfoCard
                  icon={DescriptionOutlined}
                  title="Title"
                  value={props.requestInfo.title}
                />
              </div>

              {props.requestInfo.note && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Note"
                    value={props.requestInfo.note}
                  />
                </div>
              )}

              {props.requestInfo.time_off_type && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={LocalOfferOutlined}
                    title="Type"
                    value={
                      props.requestInfo.time_off_type === 'UNPAID' ? 'Unpaid' :
                      props.requestInfo.time_off_type === 'PTO' ? 'Paid Time Off (PTO)' :
                      props.requestInfo.time_off_type === 'SICK' ? 'Sick Leave' :
                      'Not specified'
                    }
                  />
                </div>
              )}

              <div className="mb-4">
                <ModalInfoCard
                  icon={CalendarToday}
                  title="Time Off Period"
                  value={`${formatDateReadable(props.requestInfo.startDate)} ${props.requestInfo.endDate ? `- ${formatDateReadable(props.requestInfo.endDate)}` : ''}`}
                />
              </div>

              {props.requestInfo?.startTime && props.requestInfo?.endTime && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={AccessTime}
                    title="Time Off Partial Day"
                    value={`${get_t_str(props.requestInfo.startTime)} - ${get_t_str(props.requestInfo.endTime)}`}
                  />
                </div>
              )}

              {props.requestInfo.managerNote && (
                <div className="mb-4">
                  <ModalInfoCard
                    icon={ChatBubbleOutline}
                    title="Manager Note"
                    value={props.requestInfo.managerNote}
                  />
                </div>
              )}

              <div className="mb-4">
                <ModalInfoCard
                  icon={Send}
                  title="Date Submitted"
                  value={props.requestInfo.dateSubmitted}
                />
              </div>
            </div>
            <div className="h-[200px]"></div>
          </div>
        </div>
        <DrawerFooterContainerSmall>
          {((props.requestInfo.status.toLowerCase() === "pending" || props.requestInfo.status.toLowerCase() === "approved") && (props.timeline !== "History")) ? (
            <div className="w-full">
              <ButtonFilledCancel
                text="Cancel Request"
                onClick={() => handleRescindSubmit()}
              />
            </div>
          ) : (
            <div className="w-full">
              <ButtonGrayed text="Cancel Request" />
            </div>
          )}
        </DrawerFooterContainerSmall>
      </div>
    </Drawer>
  );
};

export default TimeOffMineDrawer;
